export default function getInitState() {
    return {
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "startDate",
                label: "Érvényességi idő kezdete",
                visibility: true,
                formRequired: true,
                formType: "date",                                                                                                                                                
                formSize: 3,
                formVisible: true
            },
            {
                name: "endDate",
                label: "Érvényességi idő vége",
                sort: true,
                formRequired: true,
                formType: 'date',
                formSize: 3,
                formVisible: true,
            },
            {
                name: "description",
                label: "Leírás",
                visibility: false,
                formType: "textarea",
                formSize: 12,
                formVisible: true
            },
        ],
        copyHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "startDate",
                label: "Érvényességi idő kezdete",
                visibility: true,
                formRequired: true,
                formType: "date",                                                                                                                                                
                formSize: 3,
                formVisible: true
            },
            {
                name: "endDate",
                label: "Érvényességi idő vége",
                sort: true,
                formRequired: true,
                formType: 'date',
                formSize: 3,
                formVisible: true,
            },
            {
                name: "movePatient",
                label: "Szerződéshez tartozó páciensek hozzárendelése",
                formType: "checkbox",
                formSize: 3,
                formVisible: true
            },
        ],
        patientFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToWorkersGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetPatientForm'
            },
            {
                btn_text: 'Mentés',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'saveNewPatient'
            },

        ],
        patientDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        patientHeaderFields: [
            {
                name: "id",
                label: "GroupPatient ID",
                visibility: false
            },
            {
                name: "patient.id",
                label: "Patient ID",
                visibility: false
            },
            {
                name: "patient.name",
                label: "Név",
                formVisible: true
            },
            {
                name: "patient.birthDate",
                label: "Születés dátuma",
                slot_name: "date_format"
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        patientDisplayedFields: [
            {
                name: 'name',
                label: "Név",
                filter: {
                    type: "simple"
                },
                sort: true,
                event_payload: false,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "email",
                label: "E-mail",
                enableCopy: true,
                formRequired: true,
                formType: "email",
                formSize: 4,
                formVisible: true
            },
        ],
        patientActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showPatientSearchModal'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Páciens hozzáadása',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'showAddPatient'
            }
        ],
        patientRowActions: [
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deletePatientRow'
            },
            {
                btn_text: '<i class="fas fa-exchange-alt"></i>',
                title: 'Munkavállaló áthelyezése',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'movePatientRow'
            }
        ],
        contactActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'goToContractGrid'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showContactSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új kapcsolattartó',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newContactRow'
            }
        ],
        patientSearchFields: [
            {
                name: "name",
                label: "Név",
                formType: "text",
                formSize: 3
            },
            {
                name: "patient.birthDate",
                label: "Születés dátuma",
                formType: "date",
                formSize: 3
            },
        ],

    }
}
